import React, { Suspense, useEffect } from "react";
import { Routes, Route, Navigate, useNavigate } from "react-router-dom";
import { Loader } from "../Components/Loader";
import useUser from "../Core/hook/useUser";
import { Privileges } from "../Core/Enum/enum";
import AccessDenied from "../Components/AccessDenied/AccessDenied";
import NotFound from "../Components/NotFound/NotFound";

import Dashboard from "../Pages/Dashboard";

import Setting from "../Pages/Setting/index";
import ClientReportSetting from "../Pages/Setting/clientReportSetting";

import CreateDepartment from "../Pages/Department/Create";
import ListDepartment from "../Pages/Department/List";

import CreateUser from "../Pages/User/create";
import ListUser from "../Pages/User/List";

import CreateUserRole from "../Pages/UserRole/Create";
import ListUserRole from "../Pages/UserRole/List";

import CreateUserPrivilege from "../Pages/Privilege/Create";
import ListUserPrivilege from "../Pages/Privilege/List";

import CreateRestaurant from "../Pages/Restaurant/Create";
import ListRestaurant from "../Pages/Restaurant/List";
import EditRestaurant from "../Pages/Restaurant/Edit";

import ThemeColor from "../Pages/ThemeColor/Create";

import CreatePrinter from "../Pages/Printer/Create/index";
import ListPrinter from "../Pages/Printer/List";

import CreateDriver from "../Pages/Staff/Create";
import ListDriver from "../Pages/Staff/List";
import DriverHistory from "../Pages/Staff/View";
import EmployeePdf from "../Pages/Staff/Print/employeePdf";
import AllEmployeepdf from "../Pages/Staff/Print/allEmployeepdf";
import EmployeePayrollpdf from "../Pages/Staff/staffPdf/index";

import ListPuchDetails from "../Pages/Punch/List";

import ListSchedule from "../Pages/Attendance/List";
import AdminCreateSchedule from "../Pages/Attendance/AdminEdit/AdminCreate";

import CreatePosition from "../Pages/Position/Create";
import ListPosition from "../Pages/Position/List";

import ListPayroll from "../Pages/Payroll/List";
import ConfirmPayroll from "../Pages/Payroll/ConfirmPayroll/index";
import ViewPayroll from "../Pages/Payroll/View";
import EditPayroll from "../Pages/Payroll/Edit";
import EmpReportPayroll from "../Pages/Payroll/FullView";

import ReScheduleList from "../Pages/ScheduleList/List";
import CreateScheduleList from "../Pages/ScheduleList/Create";

import EmployeeTimeScheduleList from "../Pages/EmployeeTimeSchedule/List";
import EmployeeWeeklyReport from "../Pages/EmployeeTimeSchedule/WeeklyReport";

import CreateCustomer from "../Pages/Customer/Create";
import ListCustomer from "../Pages/Customer/List";
import CustomerTransaction from "../Pages/CustomerTransaction";
import CustomerDeals from "../Pages/Customer/Deals";

import CustomerMeeting from "../Pages/Meeting/List/index";
import CreateMeeting from "../Pages/Meeting/Create/createMeetingAll";
import SettingMeeting from "../Pages/Meeting/Setting/index";
import ProfileMetting from "../Pages/Meeting/List/profile";
import CreateMeetingClient from "../Pages/Meeting/Create/createMeetingClient";
import CreateMeetingStaff from "../Pages/Meeting/Create/createMeetingStaff";

import Looping from "../Pages/Looping";

//-----------------------------------------------

import CreateProduct from "../Pages/Product/Create";
import ListProduct from "../Pages/Product/List";
import ProductDetails from "../Pages/Product/View/index";

import CreateCategory from "../Pages/Category/Create";
import ListCategory from "../Pages/Category/List";

import CreateLooping from "../Pages/Looping/Create";
import ListLooping from "../Pages/Looping/List";

import CreateProductBrand from "../Pages/ProductBrand/Create";
import ListProductBrand from "../Pages/ProductBrand/List";

import CustomerProfile from "../Pages/Profile/index";
import CoverageProfile from "../Pages/Profile/View";

import ListPolicyScenarios from "../Pages/PolicyScenarios/List up/index";

import BasicDealEdit from "../Pages/Deal/Edit/BasicDealEdit";

import EditCoverageDeal from "../Pages/Deal/EditCoverage";
import CreateCoverageDeal from "../Pages/Deal/CreateCoverage/index";

import SummaryReport from "../Pages/SummaryReport/index";
import GeneratePdf from "../Pages/SummaryReport/Pdf/secondpdf";
import SecondpdfGenerate from "../Pages/SummaryReport/Pdf/index";
import CoveragePdf from "../Pages/SummaryReport/CoveragePdf/secoundpdf";
import CoverageSecoundPdf from "../Pages/SummaryReport/CoveragePdf/index";

import CreateTodo from "../Pages/ToDo/Create";
import ListToDo from "../Pages/ToDo/List";
import ConversationsMessage from "../Pages/ToDo/Edit/index";

import PolicyListList from "../Pages/PolicyList/List";

import EmailSetting from "../Pages/EmailSetting/List";
import EmailSettingCreate from "../Pages/EmailSetting/Create";
import EmailTemplateCreate from "../Pages/EmailSetting/EmailTemplate/index";

import CreateNewsletters from "../Pages/Newsletters/Create";
import ListNewsletters from "../Pages/Newsletters/List";
import TypeNewsletters from "../Pages/Newsletters/Type";
import ViewNewsletters from "../Pages/Newsletters/Type/viewEmail";
import ListClientEmail from "../Pages/Newsletters/Type/listEmailVeiw";
import ViewNewslettersSms from "../Pages/Newsletters/Type/viewSms";
import ListClientEmailSms from "../Pages/Newsletters/Type/listSmsVeiw";
import ClientEmailCreate from "../Pages/Newsletters/Type/emailCreate";
import ClientSmsCreate from "../Pages/Newsletters/Type/smsCreate";

import CreateClientType from "../Pages/ClientType/Create";
import ListClientType from "../Pages/ClientType/List";

import CustomerTask from "../Pages/Task/List/index";
import CreateTask from "../Pages/Task/Create/createMeetingAll";
import SettingTask from "../Pages/Task/Setting/index";
import ProfileTask from "../Pages/Task/List/profile";
import CreateTaskClient from "../Pages/Task/Create/createMeetingClient";
import CreateTaskStaff from "../Pages/Task/Create/createMeetingStaff";

import WorkshopList from "../Pages/Workshop/List/index";
import WorkshopCreate from "../Pages/Workshop/Create";
import WorkshopHistroy from "../Pages/Workshop/History";
import NewsletterEmailCreateWorkshop from "../Pages/Workshop/NewsletterEmailCreate/index";
import NewsletterEmailCreateWorkshopVeiw from "../Pages/Workshop/NewsletterEmailCreate/view";
import NewsletterEmailCreateWorkshopHistory from "../Pages/Workshop/NewsletterEmailCreate/history";
import WorkshopfeedBackHistory from "../Pages/Workshop/History/feedBackHistory";

import PolicyOwnerReportList from "../Pages/PolicyOwnerReport/List/index";
import { Box, CircularProgress } from "@mui/material";

/**
 * AppRoutes will load the app routes.
 * @returns
 */
const AppRoutes = () => {
  const { userHasRight, isLoading } = useUser();
  const navigate = useNavigate();

  if (isLoading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="10vh"
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Routes>
      <Route
        element={<Suspense fallback={<Loader />}></Suspense>}
        path="/fallback"
      />
      <Route
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.DashboardView) ? (
              <Dashboard />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
        path="/dashboard"
      />
      <Route
        path="/dashboard"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.DashboardView) ? (
              <Dashboard />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/setting"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.SettingView) ? <Setting /> : <Dashboard />}
          </Suspense>
        }
      />
      <Route
        path="/department/list"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.DepartmentView) ? (
              <ListDepartment />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/department/create"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.DepartmentView) ? (
              <CreateDepartment />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/user/create"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.UserView) ? <CreateUser /> : <Dashboard />}
          </Suspense>
        }
      />
      <Route
        path="/user/list"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.UserView) ? <ListUser /> : <Dashboard />}
          </Suspense>
        }
      />
      <Route
        path="/user/role/create"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.UserView) ? (
              <CreateUserRole />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/user/role/list"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.UserView) ? (
              <ListUserRole />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/user/privilege/create"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.UserView) ? (
              <CreateUserPrivilege />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/user/privilege/list"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.UserView) ? (
              <ListUserPrivilege />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/branch/list"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.BranchView) ? (
              <ListRestaurant />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/branch/create"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.BranchView) ? (
              <CreateRestaurant />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/branch/edit/:id"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.BranchView) ? (
              <EditRestaurant />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/theme-color"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.ThemeView) ? (
              <ThemeColor />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/printer/list"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.PrinterView) ? (
              <ListPrinter />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/printer/create"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.PrinterView) ? (
              <CreatePrinter />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/team/create"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.StaffView) ? (
              <CreateDriver />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/team/list"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.StaffView) ? (
              <ListDriver />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/team-history/:id"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.StaffView) ? (
              <DriverHistory />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/punch/list"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.PunchDetailsView) ? (
              <ListPuchDetails />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/schedule/list"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.ScheduleView) ? (
              <ListSchedule />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/position/list"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.PositionView) ? (
              <ListPosition />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/position/create"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.PositionView) ? (
              <CreatePosition />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/payroll/list"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.PayrollView) ? (
              <ListPayroll />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/payroll/generate"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.GeneratePayroll) ? (
              <ConfirmPayroll />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/team/schedule/pdf/:id"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.StaffView) ? (
              <EmployeePdf />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/all/team/schedule/pdf/:id"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.StaffView) ? (
              <AllEmployeepdf />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />

      <Route
        path="/re-Schedule/list"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.ScheduleView) ? (
              <ReScheduleList />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/re-Schedule/create"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.ScheduleEdit) ? (
              <CreateScheduleList />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/Schedule/list/one-day"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.ScheduleView) ? (
              <EmployeeTimeScheduleList />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/payroll/list/:id"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.PayrollView) ? (
              <ViewPayroll />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/attendance/create"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.ScheduleEdit) ? (
              <AdminCreateSchedule />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/payroll/list/edit/:id"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.PayrollView) ? (
              <EditPayroll />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/payroll/list/emp/report/:id"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.PayrollView) ? (
              <EmpReportPayroll />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/emp/report/:id"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.PayrollView) ? (
              <EmployeePayrollpdf />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/attendance/weekly/report"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.ScheduleView) ? (
              <EmployeeWeeklyReport />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />

      {/*--------------------staf management-------------------------*/}

      <Route
        path="/policy/list"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.PoliciesView) ? (
              <ListProduct />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/policy/create"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.PoliciesView) ? (
              <CreateProduct />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/category/list"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.CoverageView) ? (
              <ListCategory />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/category/create"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.CoverageView) ? (
              <CreateCategory />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/looping/list"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.CoverageView) ? (
              <ListLooping />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/looping/create"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.CoverageView) ? (
              <CreateLooping />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/brand/list"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.InsuranceCompanyView) ? (
              <ListProductBrand />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/brand/create"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.InsuranceCompanyView) ? (
              <CreateProductBrand />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/customer/list"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.ClientView) ? (
              <ListCustomer />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/customer/create"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.ClientView) ? (
              <CreateCustomer />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/customer-history/:id"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.ClientView) ? (
              <CustomerTransaction />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/policy-history/:id"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.PoliciesView) ? (
              <ProductDetails />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/looping"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.LoopingView) ? <Looping /> : <Dashboard />}
          </Suspense>
        }
      />

      <Route
        path="/customer-deals/:id"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.ClientView) ? (
              <CustomerDeals />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/profile/customer/:customerId/policy/:policyId"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.PoliciesView) ? (
              <CustomerProfile />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/profile/customer/:customerId"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.ClientView) ? (
              <CustomerProfile />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/policy-scenarios/list"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.PoliciesView) ? (
              <ListPolicyScenarios />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/summary-report/:id"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.PoliciesView) ? (
              <SummaryReport />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/customer/:customerId/summary/pdf/:policyNumber"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.PoliciesView) ? (
              <GeneratePdf />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/customer/:customerId/summary/pdf/secound/:policyNumber"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.PoliciesView) ? (
              <SecondpdfGenerate />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/customer/:customerId/policy/:policyNumber"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.PoliciesView) ? (
              <CoverageProfile />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/coverage/deal/:dealId"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.CoverageView) ? (
              <EditCoverageDeal />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/customer/:customerId/coverage/:coverageId"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.CoverageView) ? (
              <CreateCoverageDeal />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/coverage-report/customer/:customerId/policy/:policyNumber"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.PoliciesView) ? (
              <CoveragePdf />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/coverage-report/customer/:customerId/policy/secound/:policyNumber"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.PoliciesView) ? (
              <CoverageSecoundPdf />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/policy-list"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.PoliciesView) ? (
              <PolicyListList />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/basic/deal/:dealId"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.PoliciesView) ? (
              <BasicDealEdit />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/client/meeting"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.ClientView) ? (
              <CustomerMeeting />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/client/meeting/create"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.ClientView) ? (
              <CreateMeeting />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/conversations/create"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.ToDoView) ? <CreateTodo /> : <Dashboard />}
          </Suspense>
        }
      />
      <Route
        path="/conversations/list"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.ToDoView) ? <ListToDo /> : <Dashboard />}
          </Suspense>
        }
      />
      <Route
        path="/conversations/messages/:id"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.ToDoView) ? (
              <ConversationsMessage />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/client/meeting/setting"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.ClientView) ? (
              <SettingMeeting />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/meeting/profile/:id"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.ClientView) ? (
              <ProfileMetting />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/client/meeting/client/create"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.ClientView) ? (
              <CreateMeetingClient />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/client/meeting/staff/create"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.ClientView) ? (
              <CreateMeetingStaff />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />

      <Route
        path="/email/setting/list"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.EmailView) ? (
              <EmailSetting />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/email/setting/create"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.EmailView) ? (
              <EmailSettingCreate />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/email/template/create"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.EmailView) ? (
              <EmailTemplateCreate />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/newsletters/list"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.NewslettersView) ? (
              <ListNewsletters />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/newsletters/create"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.NewslettersView) ? (
              <CreateNewsletters />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/client_type/list"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.ClientTypeView) ? (
              <ListClientType />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/client_type/create"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.ClientTypeView) ? (
              <CreateClientType />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/client/newsletters"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.NewslettersView) ? (
              <TypeNewsletters />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/client/newsletters/view/:id"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.NewslettersView) ? (
              <ViewNewsletters />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/client/newsletters/list"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.NewslettersView) ? (
              <ListClientEmail />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/client/newsletters/sms/view/:id"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.NewslettersView) ? (
              <ViewNewslettersSms />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/client/newsletters/sms/list"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.NewslettersView) ? (
              <ListClientEmailSms />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/client/task"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.ClientView) ? (
              <CustomerTask />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/client/task/create"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.ClientView) ? (
              <CreateTask />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/client/task/setting"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.ClientView) ? (
              <SettingTask />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/task/profile/:id"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.ClientView) ? (
              <ProfileTask />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/client/task/client/create"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.ClientView) ? (
              <CreateTaskClient />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/client/task/staff/create"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.ClientView) ? (
              <CreateTaskStaff />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/client/report/setting"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.SettingView) ? (
              <ClientReportSetting />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/workshop/list"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.WorkshopView) ? (
              <WorkshopList />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/workshop/create"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.WorkshopView) ? (
              <WorkshopCreate />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/workshop/history/:id"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.WorkshopView) ? (
              <WorkshopHistroy />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/workshop/newsletter/e-mail"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.WorkshopView) ? (
              <NewsletterEmailCreateWorkshop />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/workshop/newsletter/e-mail/view/:id"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.WorkshopView) ? (
              <NewsletterEmailCreateWorkshopVeiw />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/workshop/newsletter/e-mail/history"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.WorkshopView) ? (
              <NewsletterEmailCreateWorkshopHistory />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/client/newsletter/e-mail"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.NewslettersView) ? (
              <ClientEmailCreate />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/client/newsletter/sms"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.NewslettersView) ? (
              <ClientSmsCreate />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
       <Route
        path="/client/report/generate"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.ClientView) ? (
              <PolicyOwnerReportList />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/workshop/feedback/list"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.WorkshopView) ? (
              <WorkshopfeedBackHistory />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route element={<NotFound />} path="*" />
      <Route element={<AccessDenied />} path="/access-denied" />
      <Route element={<Navigate replace to="/dashboard" />} path="" />
    </Routes>
  );
};

export default AppRoutes;
